import request from '@/utils/request';

function updateProductionPlanning(item) {
  return request({
    data: item,
    method: 'put',
    url: 'production-planning'
  });
}
function exportSelection(domainID, weekByDate) {
  return request({
    method: 'get',
    url: 'production-planning/exportSelection',
    params: {
      domainID: domainID,
      weekByDate: weekByDate
    },
    responseType: 'blob'
  });
}

function getOrdersToPlan(domainID) {
  return request({
    params: { domainID },
    method: 'get',
    url: 'production-planning/getOrdersToPlan'
  });
}

function makeCurrent(domainID, weekByDate) {
  return request({
    data: { domainID, weekByDate },
    method: 'put',
    url: 'production-planning/current'
  });
}

export function getByWeek(domainID, week) {
  const url = `production-planning/domain/${domainID}/week/${week}`;
  return request({
    method: 'get',
    url: `/${url}`
  });
}

export function getCurrent(domainID) {
  const url = `production-planning/domain/${domainID}`;
  return request({
    method: 'get',
    url: `/${url}`
  });
}

export function finishPlanningOption(planningOption, domainID) {
  return request({
    data: { planningOption, domainID },
    method: 'post',
    url: 'production-planning/finishproductgroupplanning',
    timeout: 120000
  });
}

export function getPlannableYarns() {
  return request({
    method: 'get',
    url: 'production-planning/getPlannableYarns'
  });
}

export function resetPlanningOption(planningOption, domainID) {
  return request({
    data: { domainID, planningOption },
    method: 'post',
    url: 'production-planning/resetPlanningOption'
  });
}

export function planAgain(planningOption, domainID, week) {
  return request({
    data: { planningOption, domainID, week },
    method: 'put',
    url: 'production-planning/plan-again'
  });
}

export function getWorkshops(domainID, weekByDate) {
  return request({
    method: 'get',
    url: 'production-planning/workshops',
    params: {
      domainID: domainID,
      weekByDate: weekByDate
    }
  });
}

export function getSeries(domainID, weekByDate, workshopID, serialNumbers) {
  return request({
    method: 'get',
    url: 'production-planning/series',
    params: {
      domainID: domainID,
      weekByDate: weekByDate,
      workshopID: workshopID,
      serialNumbers: serialNumbers
    }
  });
}

export const storeExtensions = {
  actions: {
    updateProductionPlanning({ commit }, item) {
      return new Promise((resolve, reject) =>
        updateProductionPlanning(item)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    exportSelection({ dispatch }, { domainID, weekByDate }) {
      return new Promise((resolve, reject) =>
        exportSelection(domainID, weekByDate)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    getOrdersToPlan({ commit }, { domainID }) {
      return new Promise((resolve, reject) =>
        getOrdersToPlan(domainID)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    makeCurrent({ commit }, { domainID, weekByDate }) {
      return new Promise((resolve, reject) =>
        makeCurrent(domainID, weekByDate)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    getByWeek({ commit, dispatch }, { domainID, week }) {
      return new Promise((resolve, reject) =>
        getByWeek(domainID, week)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    getCurrent({ commit, dispatch }, { domainID }) {
      return new Promise((resolve, reject) =>
        getCurrent(domainID)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    finishPlanningOption({ commit }, { planningOption, domainID }) {
      return new Promise((resolve, reject) =>
        finishPlanningOption(planningOption, domainID)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    getPlannableYarns({ dispatch }) {
      return new Promise((resolve, reject) =>
        getPlannableYarns()
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    resetPlanningOption({ dispatch }, { planningOption, domainID }) {
      return new Promise((resolve, reject) =>
        resetPlanningOption(planningOption, domainID)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    planAgain({ dispatch }, { planningOption, domainID, week }) {
      return new Promise((resolve, reject) =>
        planAgain(planningOption, domainID, week)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    getWorkshops({ dispatch }, { domainID, weekByDate }) {
      return new Promise((resolve, reject) =>
        getWorkshops(domainID, weekByDate)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    getSeries({ dispatch }, { domainID, weekByDate, workshopID, serialNumbers }) {
      return new Promise((resolve, reject) =>
        getSeries(domainID, weekByDate, workshopID, serialNumbers)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    }
  }
};
